<template>
  <div style="min-height: 100vh" v-empty="empty" :empty-text="emptyText"></div>
</template>
<script>
export default {
  data() {
    return {
      empty: 'm-error',
      emptyText: $t('866b795eae')
    }
  }
}
</script>
